module.exports = __webpack_public_path__ + "img/bn5.bcec4705.png";